import { Inject, Injectable, Output, EventEmitter } from '@angular/core';
import { Headers, Http } from '@angular/http';
import 'rxjs/add/operator/toPromise';
import { AdalService } from '../shared/azure-authentication/adal.service';
import { BaseEndpoint } from '../app.constants';
import { UserProfile } from './userprofile.model';


@Injectable()
export class UserProfileService {
  private headers = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: Http, @Inject(BaseEndpoint) private baseEndpoint, private adalService: AdalService) {
    let jwt = this.adalService.accessToken;
    this.headers.append('Authorization', 'Bearer ' + jwt);
  }

  getUserProfile(email: string): Promise<UserProfile> {
    var url = this.baseEndpoint + 'v1/userprofile/'+ email;
    return this.http
      .get(url, { headers: this.headers })
      .toPromise()
      .then(resp => {
        return resp.json().body as UserProfile;
      })
      .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error);
    return Promise.reject(error.message || error);
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/userprofile/userprofile.service.ts